<template>
  <Dialog :title="$t('Change display columns')" v-model="currentVisible">
    <q-list>
      <q-item tag="label" v-ripple v-for="(col, i) in columns" :key="i">
        <q-item-section>
          <q-item-label>{{ col.label }}</q-item-label>
        </q-item-section>
        <q-item-section side>
          <q-toggle
            color="primary"
            v-model="col.visible"
            :val="col.key"
            dense
            :disable="isDisabled(col.visible)"
          />
        </q-item-section>
      </q-item>
    </q-list>
  </Dialog>
</template>

<script>
import Dialog from '../Dialog';

const messages = {
  en: {
    'Change display columns': 'Change display columns',
  },
  ja: {
    'Change display columns': '表示項目の変更',
  },
};

export default {
  name: 'DialogVisibleColumn',
  i18n: { messages: messages },
  components: {
    Dialog,
  },
  props: {
    value: {
      type: Boolean,
    },
    columns: {
      type: Array,
    },
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    isDisabled(visible) {
      if (this.columns.filter((col) => col.visible).length <= 1) {
        if (visible) return true;
      } else {
        return false;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
